import React from 'react';
import cl from './News.module.css';
import NewsInfo from './NewsInfo/NewsInfo';
import Product from '../Products/Product/Product';



const News = (props) => {

  let newsElements = props.newsData.map(
    n => <NewsInfo key={n.newsId}  newsId={n.newsId} newsImg={n.newsImg} newsName={n.newsName} path={n.path}/>
  );
    return (
        <section className={cl.container}>
          <h1>News</h1>
          <div className={cl.news_container}>
          {newsElements}
          </div>
        </section>
    ); 
}

export default News;
